import {commonActions} from '../../actions/commonActions';
import {orderSetList,orderSetListForExcel} from '../../actions/orderActions';
import {connect} from 'react-redux';
import List from '../../components/order/OrderList';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as areaList} from '../../containers/area/AreaListPage';
import {list as stateList} from '../../containers/area/StateListPage';
import {list as cityList} from '../../containers/area/CityListPage';
import {getItem as userInfo} from '../../containers/user/AddEditFormPage';

const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    editInvoice: (value) => {
        dispatch(editInvoice(value));
    },
    settleOrder: (value) => {
        dispatch(settle(value));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    getStateList : (value) => {
        return(dispatch(stateList(value)));
    },
    getCityList : (value) => {
        return(dispatch(cityList(value)));
    },
    getListForExcel: (value) => {
        dispatch(listForExcel(value));
    },
    getUserInfo: (id) => {
        return(dispatch(userInfo(id)))
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});


export const listForExcel = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('order/v2/orders',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(orderSetListForExcel(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

export const list = (value) => {
    return (dispatch, getState) => {
        
        let states = getState()
        let userId;

        console.log("value :",value)
        console.log("states :",states?.router?.location?.pathname)

        if(states?.router?.location?.pathname.split('/')[3]=='customer'){
            if(states.user.getItem && states.user.getItem._id) {
                userId = states.user.getItem._id
                value.customer_by = userId
            }
        }

        if(states?.router?.location?.pathname.split('/')[3]=='technician'){
            if(states.user.getItem && states.user.getItem._id) {
                userId = states.user.getItem._id
                value.technician_by = userId
            }
        }

        // if(value!=undefined || value!=null){
        //     if(value.isCustomer!=undefined){
        //         if(value.isCustomer){
        //             if(states.user.getItem && states.user.getItem._id) {
        //                 userId = states.user.getItem._id
        //                 value.customer_by = userId
        //             }
        //         } else {
        //             if(states.user.getItem && states.user.getItem._id) {
        //                 userId = states.user.getItem._id
        //                 value.technician_by = userId
        //             }
        //         }
        //     }
        // } else {
        //     if(states.user.getItem && states.user.getItem._id) {
        //         userId = states.user.getItem._id
        //         value.technician_by = userId
        //     }
        // }

        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }

        // if(value!=undefined || value!=null){
        //     delete value['isCustomer']
        // }

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('order/v2/orders',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(orderSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const editInvoice = (orderId) => {
    return (dispatch, getState) => {
        API_FETCH.delete('order/invoice/'+orderId).then(res => {
            dispatch(orderSetList(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد و امکان ویرایش فاکتور برای تکنسین فراهم شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            console.log(error);
        });
    }

}

const settle = (orderId) => {
    return (dispatch, getState) => {
        API_FETCH.get('order/settle/'+orderId).then(res => {
            dispatch(orderSetList(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.order.list,
        common       : state.common,
        initialValues: state.order.targetItem,
        areaList     : state.area.areaList,
        stateList     : state.area.stateList,
        cityList     : state.area.cityList,
        listForExcel : state.user.listForExcel,
        userInfo     : state.user.getItem,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
